import { useContext, Dispatch } from "react";

import { StateContext } from "config/state";

export const initialState = {
  myCoursesFilters: {
    pagination: { rowsPerPage: 10 },
    orderBy: ["createdAt,DESC"]
  }
};

type State = typeof initialState;

export enum actionTypes {
  SET_MY_COURSES_FILTERS = "setMyCoursesFilters",
  RESET_MY_COURSES_FILTERS = "resetMyCoursesFilters"
}

const reducer = (
  state = initialState,
  action: { type: actionTypes; payload?: any }
) => {
  switch (action.type) {
    case actionTypes.SET_MY_COURSES_FILTERS: {
      return {
        ...state,
        myCoursesFilters: action.payload
      };
    }
    case actionTypes.RESET_MY_COURSES_FILTERS: {
      return {
        ...state,
        myCoursesFilters: initialState.myCoursesFilters
      };
    }
    default:
      return state;
  }
};

export const useModuleState = (): [
  State,
  Dispatch<{ type: actionTypes; payload?: any }>
] => {
  const [state, dispatch] = useContext(StateContext);
  return [state.myCourses, dispatch];
};

export default reducer;
